<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('workersList.history') }}
          </h1>
        </v-flex>
      </v-layout>

      <v-flex d-flex xs12 mt-4 mr-4>
        <v-text-field
          v-model="filters.search"
          class="search"
          solo
          hide-details
          :placeholder="$t('workersList.historyPlaceholder')"
        />
        <v-menu
          ref="menuDate"
          :close-on-content-click="false"
          v-model="menuDate"
          :return-value.sync="filters.dates"
          max-width="280px"
          min-width="280px"
          class="pr-4 mt-2"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              v-model="filters.dates"
              prepend-icon="mdi-calendar"
              :label="$t('common.fields.rentDate')"
              readonly
              class="date"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.dates"
            color="primary lighten-1"
            width="280"
            range
            :locale="$i18n.locale"
            :selected-items-text="filters.dates.toString()"
            :allowed-dates="allowedDates"
            @input="changeDate"
          ></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex mt-5>
        <v-data-table
          :headers="headers"
          :items="list"
          :items-per-page="perPage"
          :loading="loading"
          hide-default-footer
        >
          <template #[`item.result`]="{ item }">
            {{ item.result || '-' }}
          </template>

          <template #footer>
            <v-divider />
            <div class="pt-1 pb-2">
              <v-pagination
                color="warning"
                :value="currentPage"
                :length="lastPage"
                dark
                circle
                @input="fetchList({ ...filters, page: $event })"
              />
            </div>
          </template>
        </v-data-table>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import hasPermission from '@/helpers/hasPermission';
import store from '@/store';

export default {
  async beforeRouteEnter(to, from, next) {
    await store.commit('global/setRole', null, { root: true });

    if (!hasPermission('workdesk_view_history')) {
      next('/workers-board');
    }

    if (store.getters['global/getRole'] !== 'investor') {
      next();
    } else {
      next('/investor-board');
    }
  },
  data: () => ({
    loading: false,
    menuDate: false,
    filters: {
      dates: [],
      search: '',
    },
  }),
  watch: {
    filters: {
      deep: true,
      handler(value) {
        if (value.dates.length < 2) return;
        this.fetchList(value);
      },
    },
  },
  computed: {
    ...mapState({
      list: (state) => state['workers-board'].history,
      currentPage: (state) => state['workers-board'].historyCurrentPage,
      lastPage: (state) => state['workers-board'].historyLastPage,
      perPage: (state) => state['workers-board'].historyPerPage,
    }),
    headers() {
      return [
        {
          text: this.$t('common.number'),
          value: 'num',
          sortable: false,
        },
        {
          text: this.$t('common.table.employee'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('common.fields.email'),
          value: 'email',
          sortable: false,
        },
        {
          text: this.$t('workersList.history.updatedDate'),
          value: 'createdAt',
          sortable: false,
        },
        {
          text: this.$t('auto.fields.number'),
          value: 'number',
          sortable: false,
        },
        {
          text: this.$t('workersList.history.action'),
          value: 'key',
          sortable: false,
        },
        {
          text: this.$t('driverHistory.tableHeaders.details'),
          value: 'result',
          sortable: false,
        },
        {
          text: this.$t('workersList.history.createdDate'),
          value: 'record_date',
          sortable: false,
        },
      ];
    },
    today() {
      const date = new Date();
      const formatNum = (v) => (v < 10 ? `0${v}` : v);

      return `${date.getFullYear()}-${formatNum(
        date.getMonth() + 1,
      )}-${date.getDate()}`;
    },
  },
  methods: {
    async fetchList(params) {
      this.loading = true;
      await this.$store.dispatch('workers-board/fetchHistory', params);
      this.loading = false;
    },
    fillDates() {
      const { dates } = this.$route.query;

      if (dates) this.filters.dates = dates;
      else this.filters.dates = [this.today, this.today];
    },
    changeDate(val) {
      if (val.length === 2) {
        this.$refs.menuDate.save(this.filters.dates);
      }
    },
    allowedDates(value) {
      const [from, to] = this.filters.dates;

      if (!from) return true;
      if (to) return true;

      const firstDate = new Date(from);
      const nextDate = new Date(value);

      return nextDate >= firstDate;
    },
  },
  created() {
    this.fillDates();
  },
};
</script>

<style>
.search {
  max-width: 400px;
  margin-right: 40px !important;
}
.date {
  max-width: 250px;
}
.v-pagination button {
  box-shadow: none !important;
}
</style>
